var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{class:_vm.classes},[_c('router-view'),(_vm.$store.state.modal.isShow)?_c('div',{staticClass:"modal-base"},[_c(_vm.$store.state.modal.target,{tag:"component"})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }